/** @format */

import React, { useCallback } from "react";
import { userLogInfo } from "../../app/services/logsApi";
import { User } from "../../app/services/userApi";

type Props = {
  user?: User;
  logUser?: userLogInfo;
  title?: string;
};

/**
 * displays a user's avatar
 * if both user and logUser are provided, logUser is checked for a value first
 * @param user used to display an avatar without a defined url
 * @param logUser used to display an avatar from a defined url
 * @param title sets the element title
 */
const UserAvatar: React.FC<Props> = ({ user, logUser, title }) => {
  const getAvatarSrc = useCallback(() => {
    let src;

    switch (user?.role) {
      case "wjec":
      case "admin":
        src = user.meta?.avatar;
        break;

      case "teacher":
        const firstName = user.meta.hwb?.given_name ?? "unknown";
        const lastName = user.meta.hwb?.family_name ?? "unknown";
        src = `https://ui-avatars.com/api/?name=${firstName}+${lastName}&background=random&rounded=true&bold=true&font-size=0.5`;
        break;
    }

    return src ?? "https://gravatar.com/avatar?d=mp&s=30";
  }, [user]);

  return (
    <img
      title={title}
      className="rounded-circle border-1 border bg-primary user-image"
      style={{
        width: 40,
        height: 40,
      }}
      src={logUser?.avatar ?? getAvatarSrc()}
      alt={logUser?.displayName ?? user?.meta.name ?? "Unknown User"}
    />
  );
};

export default UserAvatar;
